export default __webpack_public_path__ + "static/media/belgium.a4ae29bf.svg";